import CaptainInboxes from 'dashboard/api/captain/inboxes';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'CaptainInbox',
  API: CaptainInboxes,
  actions: mutations => ({
    delete: async function remove({ commit }, { inboxId, assistantId }) {
      commit(mutations.SET_UI_FLAG, { deletingItem: true });
      try {
        await CaptainInboxes.delete({ inboxId, assistantId });
        commit(mutations.DELETE, inboxId);
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
        return inboxId;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
        return throwErrorMessage(error);
      }
    },
    // SiteUp: muda o modo da IA desta caixa. 5 perfis (espelha
    // Captain::Assistant::AI_MODES): off / suggest_manual / suggest_auto /
    // autonomous / autonomous_suggest. Faz merge no record (preserva
    // nome/canal) via getRecord.
    updateMode: async function updateMode(
      { commit, getters },
      { inboxId, assistantId, mode }
    ) {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        await CaptainInboxes.updateMode({ inboxId, assistantId, mode });
        const current = getters.getRecord(inboxId);
        commit(mutations.EDIT, {
          ...current,
          id: inboxId,
          captain_ai_mode: mode,
        });
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return mode;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return throwErrorMessage(error);
      }
    },
    // SiteUp (SITE-7): salva o horário de atuação da IA desta caixa (independe do
    // expediente). Faz merge no record preservando nome/canal/modo da IA.
    updateAiHours: async function updateAiHours(
      { commit, getters },
      { inboxId, assistantId, aiHours }
    ) {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        await CaptainInboxes.updateAiHours({ inboxId, assistantId, aiHours });
        const current = getters.getRecord(inboxId);
        commit(mutations.EDIT, {
          ...current,
          id: inboxId,
          captain_ai_hours: aiHours,
        });
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return aiHours;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return throwErrorMessage(error);
      }
    },
  }),
});
